/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetTypeResponseDto
 */
export interface AssetTypeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetTypeResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeResponseDto
     */
    description?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetTypeResponseDto
     */
    metadataSchema?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof AssetTypeResponseDto
     */
    subsystemCount: number;
}

/**
 * Check if a given object implements the AssetTypeResponseDto interface.
 */
export function instanceOfAssetTypeResponseDto(value: object): value is AssetTypeResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('subsystemCount' in value) || value['subsystemCount'] === undefined) return false;
    return true;
}

export function AssetTypeResponseDtoFromJSON(json: any): AssetTypeResponseDto {
    return AssetTypeResponseDtoFromJSONTyped(json, false);
}

export function AssetTypeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetTypeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'metadataSchema': json['metadataSchema'] == null ? undefined : json['metadataSchema'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'subsystemCount': json['subsystemCount'],
    };
}

export function AssetTypeResponseDtoToJSON(json: any): AssetTypeResponseDto {
    return AssetTypeResponseDtoToJSONTyped(json, false);
}

export function AssetTypeResponseDtoToJSONTyped(value?: AssetTypeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'metadataSchema': value['metadataSchema'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'subsystemCount': value['subsystemCount'],
    };
}

